// src/pages/docs/custom/edit.jsx
import { Typography, Box, Link, Button } from '@mui/material';
import DocsLayout from 'layout/DocsLayout';
import commandList from 'data/commands';
import { useLocation } from 'react-router-dom';
import { getAdjacentCommands } from 'components/getAdjacentCommands';

const CustomEditCommand = () => {
  const location = useLocation();
  const command = commandList.find((cmd) => cmd.path === location.pathname);
  const { prev, next } = getAdjacentCommands(location.pathname);

  return (
    <DocsLayout>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 4, flexWrap: 'wrap', maxWidth: 800 }}>
        {/* 왼쪽 텍스트 영역 */}
        <Box sx={{ flex: 1, minWidth: 260 }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            {"/커스텀 수정"}
          </Typography>
          <Typography variant="body1" sx={{ mt: -2, mb: 3 }}>
          {command?.description ?? '설명이 없습니다.'}
          </Typography>
          <Typography variant="h6">
            {"사용법: /커스텀 수정 <명령어>"}<br />{"<>는 필수 사항입니다."}
          </Typography>
          <Typography variant="body1" sx={{ mt: 3, mb: 3}}>
          {"예시: /커스텀 수정 안녕, /커스텀 수정 !안녕"}<br />
          {"자세한 설명은 "}
            <Link
                href="/docs/custom/create"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: '#5ec8f2' }}
            >
                /커스텀 생성 
            </Link>
            {" 명령어를 확인해 주세요."}
          </Typography>

        </Box>

        {/* 오른쪽 이미지 영역 */}
        <Box
          component="img"
          src="/commands/customedit.png"
          alt="설명 이미지"
          sx={{
            width: '100%',
            maxWidth: 400,
            borderRadius: 2,
            flexShrink: 0,
            mx: 'auto',
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center', md: 'space-between' },
            gap: 4,
            width: { xs: '100%',md: 'auto' },
            mt:{md:-3}
          }}
        >
        {prev && (
          <Button href={prev.path} variant="outlined"sx={{height: 36, width:118 }}>
            ← {prev.name}
          </Button>
        )}
        {next && (
          <Button href={next.path} variant="outlined"sx={{height: 36, width:118 }}>
            {next.name} →
          </Button>
        )}
        </Box>
      </Box>
    </DocsLayout>
  );
};

export default CustomEditCommand;
